// Neutral
export const NEUTRAL_0 = '#FFFFFF';
export const NEUTRAL_1 = '#F4F6F6';
export const NEUTRAL_2 = '#E3E8EA';
export const NEUTRAL_3 = '#C9D5DB';
export const NEUTRAL_4 = '#A9BCC7';
export const NEUTRAL_5 = '#849DAD';
export const NEUTRAL_6 = '#607A8D';
export const NEUTRAL_7 = '#445B70';
export const NEUTRAL_8 = '#2B3B4E';
export const NEUTRAL_9 = '#171F2C';
export const NEUTRAL_10 = '#06090D';

// Ajaib Blue
export const AJAIB_BLUE_1 = '#E1F2FA';
export const AJAIB_BLUE_2 = '#B2E2FF';
export const AJAIB_BLUE_3 = '#82C9FF';
export const AJAIB_BLUE_4 = '#59A8FF';
export const AJAIB_BLUE_5 = '#3A83F9';
export const AJAIB_BLUE_6 = '#165BCC';
export const AJAIB_BLUE_7 = '#083C96';
export const AJAIB_BLUE_8 = '#02225D';
export const AJAIB_BLUE_9 = '#000D26';

// Green
export const GREEN_1 = '#CEE0D4';
export const GREEN_2 = '#B3D7C0';
export const GREEN_3 = '#90C9A4';
export const GREEN_4 = '#63B782';
export const GREEN_5 = '#2F9D5B';
export const GREEN_6 = '#05833A';
export const GREEN_7 = '#00612B';
export const GREEN_8 = '#003C1D';
export const GREEN_9 = '#00190D';

// Red
export const RED_1 = '#FFE0E0';
export const RED_2 = '#FFD4D4';
export const RED_3 = '#FFBBBB';
export const RED_4 = '#FF9292';
export const RED_5 = '#F65858';
export const RED_6 = '#CC1C15';
export const RED_7 = '#990C00';
export const RED_8 = '#640C00';
export const RED_9 = '#300800';

// Yellow
export const YELLOW_1 = '#FFF0E0';
export const YELLOW_2 = '#FFEBCB';
export const YELLOW_3 = '#FFE0A9';
export const YELLOW_4 = '#FFD079';
export const YELLOW_5 = '#FABB39';
export const YELLOW_6 = '#CA8A0A';
export const YELLOW_7 = '#916000';
export const YELLOW_8 = '#543800';
export const YELLOW_9 = '#191100';

// Cyan
export const CYAN_1 = '#D0F7F1';
export const CYAN_2 = '#93F3E5';
export const CYAN_3 = '#59EBD9';
export const CYAN_4 = '#29DCCC';
export const CYAN_5 = '#06C6BC';
export const CYAN_6 = '#00A39B';
export const CYAN_7 = '#007673';
export const CYAN_8 = '#004746';
export const CYAN_9 = '#001919';

// Purple
export const PURPLE_1 = '#F0E8FF';
export const PURPLE_2 = '#CDB2FF';
export const PURPLE_3 = '#AA7BFF';
export const PURPLE_4 = '#8B4BFF';
export const PURPLE_5 = '#7325F8';
export const PURPLE_6 = '#5C10D1';
export const PURPLE_7 = '#4805A2';
export const PURPLE_8 = '#340170';
export const PURPLE_9 = '#200040';

// Regal Blue
export const REGAL_BLUE_1 = '#D6E4FF';
export const REGAL_BLUE_2 = '#C3D9FF';
export const REGAL_BLUE_3 = '#A4C2F2';
export const REGAL_BLUE_4 = '#7AA0D7';
export const REGAL_BLUE_5 = '#4C76B2';
export const REGAL_BLUE_6 = '#244F8E';
export const REGAL_BLUE_7 = '#053076';
export const REGAL_BLUE_8 = '#011052';
export const REGAL_BLUE_9 = '#000038';

// Slate Gray
export const SLATE_GRAY_1 = '#F5F5F5';
export const SLATE_GRAY_2 = '#E1ECF0';
export const SLATE_GRAY_3 = '#C1D6DF';
export const SLATE_GRAY_4 = '#98B2BD';
export const SLATE_GRAY_5 = '#6A848F';
export const SLATE_GRAY_6 = '#435A64';
export const SLATE_GRAY_7 = '#2A3D45';
export const SLATE_GRAY_8 = '#202628';
export const SLATE_GRAY_9 = '#171717';
